var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindreplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 60,
    height: 60,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.044 22.157l5.707 5.708-1.885 1.887-5.707-5.708c-2.027 1.634-4.633 2.623-7.47 2.623-0.008 0-0.015 0-0.023-0h0.001c-0.002 0-0.003 0-0.005 0-4.684 0-8.741-2.684-10.717-6.598l-0.031-0.069h8.087l-1.739 2.897c1.271 0.694 2.783 1.103 4.391 1.103 0.005 0 0.010 0 0.015 0h-0.001c0.004 0 0.009 0 0.015 0 2.523 0 4.812-1.005 6.487-2.635l-0.002 0.002 0.2-0.2c1.629-1.674 2.633-3.962 2.633-6.485 0-0.005 0-0.010 0-0.015v0.001c0-0.927-0.135-1.821-0.387-2.667h2.756c0.195 0.857 0.297 1.751 0.297 2.667 0 0.006 0 0.013 0 0.020 0 2.837-0.989 5.444-2.641 7.493l0.018-0.023zM25.42 9.333h-8.087l1.739-2.897c-1.271-0.694-2.783-1.103-4.391-1.103-0.005 0-0.010 0-0.015 0h0.001c-5.157 0-9.333 4.176-9.333 9.333 0 0.927 0.135 1.821 0.387 2.667h-2.756c-0.189-0.799-0.297-1.717-0.297-2.66 0-0.002 0-0.004 0-0.007v0c0-6.631 5.369-12 12-12 0.002 0 0.003 0 0.005 0 4.684 0 8.741 2.684 10.717 6.598l0.031 0.069z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindreplace);
export default __webpack_public_path__ + "static/media/findreplace.1519f0c2bd299d7ccedc126302b6c0c1.svg";
export { ForwardRef as ReactComponent };